import React, { useState } from 'react';
import Button from 'antd/lib/button';
import DownloadOutlined from '@ant-design/icons/lib/icons/DownloadOutlined';
import { useCustomizableTableContext } from 'src/components/table/CustomizableTableContext';
import { ICustomerUtilityBillsQuery, toBillExportFields } from 'src/domain/customer-utility-bill';
import { useExportCustomerUtilityBillsMutation } from 'src/domain/customer-utility-bill/queries';
import { DownloadBillsXlsxModal, IDownloadBillsXlsxFormData } from './DownloadBillsXlsxModal';

interface Props {
    query: ICustomerUtilityBillsQuery;
}

// "Download XLSX" button + options modal. Must render inside the bills table's CustomizableTableContextProvider,
// since the "Current view" option exports the visible columns in their current order.
export const CustomerUtilityBillExportButton: React.FC<Props> = ({ query }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const exportBills = useExportCustomerUtilityBillsMutation();
    const { columns } = useCustomizableTableContext();

    const handleSubmit = ({ applyFilters, columns: columnsOption }: IDownloadBillsXlsxFormData) => {
        setModalOpen(false);

        // Pagination is never exported; "Download all" keeps only the sort so the file order matches the table.
        const { offset, limit, ...filteredQuery } = query;
        const exportQuery: ICustomerUtilityBillsQuery = applyFilters ? filteredQuery : { sortField: query.sortField, sortOrder: query.sortOrder };
        const fields = columnsOption === 'current' ? toBillExportFields(columns) : undefined;

        exportBills.mutate({ query: exportQuery, fields });
    };

    return (
        <>
            <Button size="large" loading={exportBills.isLoading} icon={<DownloadOutlined />} onClick={() => setModalOpen(true)}>
                Download XLSX
            </Button>
            {modalOpen && <DownloadBillsXlsxModal onClose={() => setModalOpen(false)} onSubmit={handleSubmit} />}
        </>
    );
};
